import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";

export function Sidebar() {
  const { t } = useTranslation();
  return (
    <aside className="sidebar">
      <div className="sidebar-logo">
        <h2>Nexus</h2>
        <span className="badge">Admin</span>
      </div>
      <nav>
        <NavLink to="/dashboard" className={({ isActive }) => isActive ? 'active' : ''}>
          <span className="nav-icon">📊</span>
          <span>{t("admin.sidebar.dashboard")}</span>
        </NavLink>
        <NavLink to="/tenants" className={({ isActive }) => isActive ? 'active' : ''}>
          <span className="nav-icon">🏢</span>
          <span>{t("admin.sidebar.tenants")}</span>
        </NavLink>
        <NavLink to="/sso" className={({ isActive }) => isActive ? 'active' : ''}>
          <span className="nav-icon">🔑</span>
          <span>{t("admin.sidebar.sso")}</span>
        </NavLink>
        <NavLink to="/users" className={({ isActive }) => isActive ? 'active' : ''}>
          <span className="nav-icon">👥</span>
          <span>{t("admin.sidebar.users")}</span>
        </NavLink>
        <NavLink to="/features" className={({ isActive }) => isActive ? 'active' : ''}>
          <span className="nav-icon">✨</span>
          <span>{t("admin.sidebar.features")}</span>
        </NavLink>
        <NavLink to="/sessions" className={({ isActive }) => isActive ? 'active' : ''}>
          <span className="nav-icon">🕒</span>
          <span>{t("admin.sidebar.sessions")}</span>
        </NavLink>
        <NavLink to="/api-tokens" className={({ isActive }) => isActive ? 'active' : ''}>
          <span className="nav-icon">🔐</span>
          <span>{t("admin.sidebar.apiTokens")}</span>
        </NavLink>
      </nav>
      <div className="sidebar-footer">
        <p className="muted">v1.0.0</p>
      </div>
    </aside>
  );
}
